import type { InspectaRuntimeConfig } from '../types/config';

const sanitizeUrl = (value: string | undefined | null) => value?.replace(/\/$/, '') ?? undefined;

const envApiBaseUrl =
  sanitizeUrl(import.meta.env.VITE_API_BASE_URL) ??
  sanitizeUrl(import.meta.env.VITE_API_URL);

const DEFAULT_CONFIG: InspectaRuntimeConfig = {
  apiBaseUrl: envApiBaseUrl || '/api'
};

const isBrowser = typeof window !== 'undefined';

const readWindowConfig = (): InspectaRuntimeConfig | null => {
  if (!isBrowser) {
    return null;
  }

  const config = (window as typeof window & { __INSPECTA_CONFIG__?: InspectaRuntimeConfig }).__INSPECTA_CONFIG__;

  if (!config) {
    return null;
  }
console.log(config);
  return {
    ...config,
    apiBaseUrl: config.apiBaseUrl?.replace(/\/$/, '') || DEFAULT_CONFIG.apiBaseUrl
  };
};

export const getRuntimeConfig = (): InspectaRuntimeConfig => {
  const runtimeConfig = readWindowConfig();

  return {
    ...DEFAULT_CONFIG,
    ...(runtimeConfig ?? {})
  };
};
